export default __webpack_public_path__ + "static/media/products-list-white.2385e159.svg";